import { RootState } from "../rootReducer"

export const selectGetSurveysState = (state: RootState) => state.surveys.surveys
export const selectSurveys = (state: RootState) => state.surveys.surveys.data ?? []
export const selectCreateSurveyState = (state: RootState) => state.surveys.createSurvey
export const selectUpdateSurveyState = (state: RootState) => state.surveys.updateSurvey
export const selectGlobalUserSurvey = (state: RootState) => state.surveys.globalUserSurvey
